module.exports = __webpack_public_path__ + "img/logo.a1ca4dac.png";